import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import './EventDetailsPage.css';

function EventDetailsPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMapVisible, setMapVisible] = useState(false);
  const [isGoogleMapVisible, setGoogleMapVisible] = useState(false);
  const [isDescriptionVisible, setDescriptionVisible] = useState(false);
  const [isCartModalVisible, setCartModalVisible] = useState(false);

 
  const [quantity, setQuantity] = useState(1);
  const [deliveryOption, setDeliveryOption] = useState('Mobile Delivery');

  const [eventAreas, setEventAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState(""); 
  const [ticketPrice, setTicketPrice] = useState(0); 
  const [handlingFee, setHandlingFee] = useState(0);

  
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/events/${id}`)
      .then(response => response.json())
      .then(data => {
        setEvent(data);
        setEventAreas(data.eventAreas || []); // Ensure eventAreas is not null
        if (data.eventAreas?.length > 0) {
          setSelectedArea(null); // Set default area to first option
          setTicketPrice(0);
          setHandlingFee(0);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error("Error al cargar el evento:", error);
        setError("No se pudo cargar el evento.");
        setLoading(false);
      });
  }, [id]);


  useEffect(() => {
    if (event) {
      document.title = event.title;
  
      const setMetaTag = (property, content) => {
        let tag = document.querySelector(`meta[property='${property}']`);
        if (!tag) {
          tag = document.createElement('meta');
          tag.setAttribute('property', property);
          document.head.appendChild(tag);
        }
        tag.setAttribute('content', content);
      };
  
      setMetaTag('og:title', event.title);
      setMetaTag('og:description', event.description?.substring(0, 150) + '...');
      setMetaTag('og:image', event.imageUrl);
      setMetaTag('og:url', window.location.href);
      setMetaTag('og:type', 'article');
  
      setMetaTag('twitter:card', 'summary_large_image');
      setMetaTag('twitter:title', event.title);
      setMetaTag('twitter:description', event.description?.substring(0, 150) + '...');
      setMetaTag('twitter:image', event.imageUrl);
    }
  }, [event]);
  
  

  if (loading) {
    return <div className="loading-message">Cargando evento...</div>;
  }

  if (error || !event) {
    return <div className="error-message">El evento no existe o está cargando...</div>;
  }

  const areaPrices = {
    General: 500,
    VIP: 1000,
  };

  //    'Retirar en Santo Domingo': 0,
  // 'Delivery en Santo Domingo': 100,
  const deliveryCosts = {
    'Mobile Delivery': 0,
  };

  const deliveryDescriptions = {
    'Retirar en Santo Domingo': 'Boleto Físico para ser retirado en nuestras oficinas...',
    'Delivery en Santo Domingo': 'Boleto Físico para ser enviado por delivery en Santo Domingo...',
    'Mobile Delivery': 'Ticket Digital, será enviado a su correo electrónico.',
  };



  const calcularCargoPorManejo = (precio) => {
    let porcentajeCargo;
  
    if (precio < 1000) {
      porcentajeCargo = 0.15; // 15%
    } else if (precio >= 1000 && precio < 3000) {
      porcentajeCargo = 0.10; // 10%
    } else {
      porcentajeCargo = 0.07; // 7%
    }
  
    return Math.round(precio * porcentajeCargo); // Redondea el cargo por manejo
  };

  const deliveryCost = deliveryCosts[deliveryOption];
  const totalPrice = (ticketPrice + handlingFee) * quantity + deliveryCost;

  const handleAddToCart = () => {
    if (!selectedArea) {
      alert("⚠️ Debes seleccionar un área antes de continuar.");
      return;
    }
  
    // Find selected area details (including its ID)
    const selectedAreaData = eventAreas.find(area => area.name === selectedArea);
    if (!selectedAreaData) {
      alert("⚠️ Error: Área seleccionada no válida.");
      return;
    }
  
    const cartItem = {
      id: event.id,
      title: event.title,
      area: selectedArea, // Name of the area
      eventAreaId: selectedAreaData.id, // ✅ Ensure the eventAreaId is included
      quantity,
      deliveryOption,
      ticketPrice, // ✅ Store ticket price
      handlingFee, // ✅ Store handling fee
      totalPrice,  // ✅ Store total cost
    };
  
    addToCart(cartItem);
    setCartModalVisible(true);
  };
  
  

  // Extraer coordenadas del campo `location`
  const [lat, lng] = event.location.split(",").map(coord => coord.trim());

  return (
    <div className="event-details">
      <div className="event-image-container">
        <button className="map-button" onClick={() => setMapVisible(true)}>Ver Mapa del Evento</button>
        <button className="description-button" onClick={() => setDescriptionVisible(true)}>Ver Descripción Completa</button>
        <img src={event.imageUrl} alt={event.title} />
      </div>

      <div className="event-info-expanded">
        <h1>Detalles del evento</h1>

        {/* ✅ Se restauró la descripción */}
        <div className="event-description">
          <p><h2><strong>{event.title}</strong></h2></p>
        </div>

        {event.igUrl && (
        <div className="organizer-instagram">
          <strong>IG Organizador: </strong>
          <a
            href={`https://www.instagram.com/${event.igUrl.replace('@', '')}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: '#000' }}
          >
            {event.igUrl.replace('@', '')}
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="Instagram"
              style={{ width: '20px', height: '20px', marginLeft: '8px', verticalAlign: 'middle' }}
            />
          </a>

        </div>
      )}

        <table className="event-details-table">
          <tbody>
            <tr>
              <td><strong>Fecha:</strong></td>
              <td>{new Date(event.date).toLocaleDateString('es-DO', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
            </tr>
            <tr>
              <td><strong>Hora de Inicio:</strong></td>
              <td>{new Date(event.date).toLocaleTimeString('es-DO', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
              })}</td>
            </tr>
            <tr>
              <td><strong>Lugar:</strong></td>
              <td>
                {event.placeName}
                <button className="google-map-button" onClick={() => setGoogleMapVisible(true)}>
                  <FaMapMarkerAlt />
                </button>
              </td>
            </tr>
            <tr>
              <td><strong>Ciudad:</strong></td>
              <td>{event.placeCity}</td>
            </tr>
            <tr>
              <td><strong>Dirección:</strong></td>
              <td>{event.placeAddress}</td>
            </tr>
          </tbody>
        </table>

        <div className="purchase-section-expanded">
          <h2>Compra de Tickets</h2>
          <table className="ticket-options-table">
            <tbody>
            <tr>
              <td><strong>Área:</strong></td>
              <td>
                <select
                  value={selectedArea || "default"} // 🔹 Controlado por el estado
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    setSelectedArea(selectedValue);

                    if (selectedValue === "") {
                      setTicketPrice(0);
                      setHandlingFee(0);
                    } else {
                      const selected = eventAreas.find(area => area.name === selectedValue);
                      if (selected) {
                        setTicketPrice(selected.price);
                        setHandlingFee(calcularCargoPorManejo(selected.price));
                      }
                    }
                  }}
                >
                  <option value="default" disabled>Seleccionar Área</option> {/* 🔹 Bloqueado para que no pueda ser seleccionado de nuevo */}
                  {eventAreas.map((area) => (
                    <option key={area.id} value={area.name}>
                      {area.name} - RD${area.price}
                    </option>
                  ))}
                </select>
              </td>
              </tr>
              <tr>
              <td>Cantidad:</td>
              <td>
                <select
                  value={quantity}
                  onChange={(e) => setQuantity(parseInt(e.target.value))}
                >
                  {[1, 2, 3, 4, 5, 6].map(q => (
                    <option key={q} value={q}>{q}</option>
                  ))}
                </select>
              </td>
            </tr>
              <tr>
                <td>Opciones de Entrega:</td>
                <td>
                  <select value={deliveryOption} onChange={(e) => setDeliveryOption(e.target.value)}>
                    {Object.keys(deliveryCosts).map(option => (
                      <option key={option} value={option}>{option} - RD${deliveryCosts[option]}</option>
                    ))}
                  </select>
                </td>
              </tr>
            </tbody>
          </table>

          <div className="delivery-description-box">
            <p>{deliveryDescriptions[deliveryOption]}</p>
          </div>

          <table className="purchase-summary">
            <tbody>
              <tr>
                <td><strong>Precio por ticket:</strong></td>
                <td>RD${ticketPrice}</td>
              </tr>
              <tr>
                <td><strong>Costo por manejo:</strong></td>
                <td>RD${handlingFee} por ticket</td>
              </tr>
              <tr>
                <td><strong>Costo de entrega:</strong></td>
                <td>RD${deliveryCost}</td>
              </tr>
              <tr className="total-row">
                <td><strong>Total a pagar:</strong></td>
                <td><strong>RD${totalPrice}</strong></td>
              </tr>
            </tbody>
          </table>

          <button 
  onClick={handleAddToCart} 
  className="add-to-cart-button" 
  disabled={!selectedArea || selectedArea === "default"} // ✅ Se deshabilita si no hay un área seleccionada
>
  Añadir al Carrito
</button>

        </div>
      </div>

      {isDescriptionVisible && (
        <div className="map-modal" onClick={() => setDescriptionVisible(false)}>
          <div className="map-content">
            <h2>Descripción Completa del Evento</h2>
            <div
              className="event-description-html"
              dangerouslySetInnerHTML={{ __html: event.description }}
            ></div>
            <button className="close-button" onClick={() => setDescriptionVisible(false)}>Cerrar</button>
          </div>
        </div>
      )}

      {isCartModalVisible && (
        <div className="modal-overlay" onClick={() => setCartModalVisible(false)}>
          <div className="modal-content">
            <h3>El artículo ha sido añadido al carrito</h3>
            <button onClick={() => navigate('/')} className="continue-shopping-button">Continuar Comprando</button>
            <button onClick={() => navigate('/cart')} className="go-to-cart-button">Ir al Carrito</button>
          </div>
        </div>)
        }
        
      {isMapVisible && (
        <div className="map-modal" onClick={() => setMapVisible(false)}>
          <div className="map-content">
            <h2>Mapa del Evento</h2>
            <img src={event.imageMapUrl} alt="Mapa del Evento" />
            <button className="close-button" onClick={() => setMapVisible(false)}>Cerrar</button>
          </div>
        </div>
      )}

      {isGoogleMapVisible && (
        <div className="map-modal" onClick={() => setGoogleMapVisible(false)}>
          <div className="map-content">
            <h2>Google Maps</h2>
            <iframe
              src={`https://maps.google.com/maps?q=${lat},${lng}&hl=es&z=15&output=embed`}
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              title="Ubicación del evento"
            ></iframe>
            <button className="close-button" onClick={() => setGoogleMapVisible(false)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>   
  );
}

export default EventDetailsPage;
